export type vertexAIProps = {
    aiInputText: string;
    setTextAreaValue: (value: string) => void;
    aiMaxLength: number;
    via?: number;
    tabIndex?: number;
};

export enum AiMenuOptions {
    Summarize = 'Summarize',
    Bullets = 'Summarize with bullets',
    Clarity = 'Re-write for clarity',
    Positivity = 'Re-write for positivity',
    Goals = 'Create SMART Goals',
}

export enum AiMode {
    Summarize = 'Summarize',
    Bullets = 'Bullets',
    Clarity = 'Clarity',
    Positivity = 'Positivity',
    Goals = 'Goals',
    Strength = 'Strength',
}

export function getAiMenuOptionValue(key: string): string | undefined {
    if (key in AiMenuOptions) {
        return AiMenuOptions[key as keyof typeof AiMenuOptions];
    }
    return undefined; // Return undefined for invalid keys
}
